import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EditUserData, GetUserData } from '../../redux/Slices/UserSlice'
import notify from "./../UseNotification"


const UseEditData = () => {

    let body;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const egyptPhoneRegex = /^(010|011|012|015)\d{8}$/;
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [editLoading, setEditLoading] = useState(true)
    const [UserName, setUserName] = useState("")
    const [UserPhone, setUserPhone] = useState("")
    const [UserEmail, setUserEmail] = useState("")
    const [Editshow, setEditshow] = useState(false)
    const [IsEditPress, setIsEditPress] = useState(false)
    const [EditValidate, setEditValidate] = useState(false)
    const { userData, editUserData } = useSelector(state => state.UserReducer)

    // handle get userData
    const handleGetUserData = async () => {
        setLoading(true)
        await dispatch(GetUserData())
        setLoading(false)
    }

    // run get user data
    useEffect(() => {
        handleGetUserData()
    }, [])


    // handle get data request response 
    useEffect(() => {
        if (loading === false) {
            if (userData && userData.status === 200 && userData.data) {
                setUserName(userData.data.data.name)
                setUserPhone(userData.data.data.phone)
                setUserEmail(userData.data.data.email)
            }
        }
    }, [loading])

    // handle modal close
    const handleEditClose = () => {
        setEditshow(false)
    }

    // handle modal show
    const HandleEditShow = () => {
        setEditshow(true)
    }

    // handle user name
    const changeUserName = (e) => {
        setUserName(e.target.value)
        if (e.target.value === "") {
            notify("Please, enter your user name", "warn")
        }
    }

    // handle user phone
    const changeUserPhone = (e) => {
        setUserPhone(e.target.value)
        if (e.target.value === "") {
            notify("Please, enter your phone", "warn")
        }
        else if (!e.target.value.match(egyptPhoneRegex)) {
            notify("phone is not egyption number", "error")
        }
    }

    // handle user email
    const changeUserEmail = (e) => {
        setUserEmail(e.target.value)
        if (e.target.value === "") {
            notify("Please, enter your email", "warn")
        }
        else if (!e.target.value.match(emailRegex)) {
            notify("please, enter correct email", "error")
        }
    }

    // handle disable save button
    useEffect(() => {
        if (UserName && UserPhone && UserEmail && UserPhone.match(egyptPhoneRegex) && UserEmail.match(emailRegex)) {
            setEditValidate(true);
        } else {
            setEditValidate(false);
        }
    }, [UserName, UserPhone, UserEmail])

    // handle edit user data
    const handleEditData = async () => {
        setEditLoading(true)
        setIsEditPress(true)
        if (userData.data.data.email === UserEmail) {
            body = {
                name: UserName,
                phone: UserPhone,
            }
        } else {
            body = {
                name: UserName,
                phone: UserPhone,
                email: UserEmail
            }
        }
        await dispatch(EditUserData(body))
        setEditLoading(false)
    }

    // handle the edit data request respone
    useEffect(() => {
        if (editLoading === false) {
            if (editUserData && editUserData.status === 200) {
                notify("Data Changed", "success")
                window.location.reload(false)
            } else {
                notify("enter correct data", "error")
            }
        }
    }, [editLoading])



    return [editLoading,EditValidate, IsEditPress, loading, HandleEditShow, UserName, changeUserName, UserPhone, changeUserPhone, UserEmail, changeUserEmail, handleEditData, Editshow, handleEditClose]
}

export default UseEditData
